import { Button, ButtonProps, Link, LinkProps } from "@mui/material";

export const AuthenticationActionButtonComponent = {
  Button: "button",
  Link: "link",
} as const;

type AuthenticationActionButtonComponent =
  (typeof AuthenticationActionButtonComponent)[keyof typeof AuthenticationActionButtonComponent];

type ActionButtonProps = Omit<
  ButtonProps,
  "variant" | "color" | "disableElevation" | "fullWidth" | "size"
>;

type AuthenticationActionButtonProps<T extends AuthenticationActionButtonComponent> = {
  as?: T;
} & (T extends typeof AuthenticationActionButtonComponent.Button ? ActionButtonProps : LinkProps);

export default function AuthenticationActionButton<
  T extends AuthenticationActionButtonComponent = "button",
>({ children, as = "button" as T, ...props }: AuthenticationActionButtonProps<T>) {
  if (as === AuthenticationActionButtonComponent.Link) {
    return (
      <Link
        {...(props as LinkProps)}
        sx={{
          background: "linear-gradient(90.25deg, #5BC4FF 0%, #9042DB 100%)",
          borderRadius: "164px",
          padding: "12px 24px",
          fontWeight: 500,
          fontSize: "16px",
          lineHeight: "24px",
          color: "white",
          boxShadow: "0px 6px 6px -3px #0000000F, 0px 4px 18px 3px #0000000F",
          display: "block",
          textAlign: "center",
          "&:hover": {
            textDecoration: "none",
          },
          "&:focus": {
            outline: "none",
          },
          ...props.sx,
        }}
      >
        {children}
      </Link>
    );
  }

  return (
    <Button
      {...(props as ButtonProps)}
      disableElevation
      fullWidth
      size="large"
      variant="contained"
      color="primary"
      sx={{
        background: "linear-gradient(90.25deg, #5BC4FF 0%, #9042DB 100%)",
        borderRadius: "164px",
        padding: "12px 24px",
        fontWeight: 500,
        fontSize: "16px",
        lineHeight: "24px",
        color: "white",
        boxShadow: "0px 6px 6px -3px #0000000F, 0px 4px 18px 3px #0000000F",
        ...props.sx,
      }}
    >
      {children}
    </Button>
  );
}
